import * as yup from "yup";
import { useTranslation } from "react-i18next";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";

const UpdateClientCampaignForm = ({ campaign, onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    code: yup
      .string()
      .required(
        t("clients.detail.tabs.campaigns.updateForm.fields.code.required"),
      ),
    name: yup
      .string()
      .required(
        t("clients.detail.tabs.campaigns.updateForm.fields.name.required"),
      ),
  });

  const defaultValues = {
    code: campaign?.code,
    name: campaign?.name,
    description: campaign?.description,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
      isCreationForm={false}
    >
      <FormInput
        name="code"
        label={t("clients.detail.tabs.campaigns.updateForm.fields.code.label")}
        required
      />
      <FormInput
        name="name"
        label={t("clients.detail.tabs.campaigns.updateForm.fields.name.label")}
        required
      />
      <FormInput
        name="description"
        label={t(
          "clients.detail.tabs.campaigns.updateForm.fields.description.label",
        )}
      />
    </BaseForm>
  );
};

export default UpdateClientCampaignForm;
